var map = {
	"./big-slider/big-slider.js": [
		52,
		52
	],
	"./profile-reviews/profile-reviews.js": [
		490,
		490
	],
	"./search-header/search-header.js": [
		129,
		129
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 749;
module.exports = webpackAsyncContext;